module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search navigatable",
    class: {
      inverted: _vm.inverted
    },
    on: {
      "click": _vm.focus
    }
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.searching) ? _c('span', {
    staticClass: "fa fa-spin fa-spinner",
    on: {
      "click": _vm.focus
    }
  }) : _c('span', {
    staticClass: "fa fa-search fa-fw",
    on: {
      "click": _vm.focus
    }
  })]), _vm._v(" "), (_vm.showResults && _vm.results.length) ? _c('div', {
    staticClass: "results list-group",
    class: {
      searching: _vm.searching
    }
  }, [(_vm.searching) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.results), function(reservation) {
    return _c('router-link', {
      key: reservation.id,
      staticClass: "list-group-item result navigatable",
      attrs: {
        "to": {
          name: 'reservations.view',
          params: {
            id: reservation.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "pull-right muted"
    }, [_c('i', [_vm._v(_vm._s(reservation.room.title))])]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(reservation.name))]), _c('br'), _vm._v(" "), _c('small', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(reservation.arrival.date, "DD/MM")) + " \n                    "), _c('span', {
      staticClass: "fa fa-long-arrow-right fa-fw"
    }), _vm._v("\n                    " + _vm._s(_vm._f("moment")(reservation.departure.date, "DD/MM/YY")) + "\n                ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [(_vm.results.length === 8) ? _c('div', {
    staticClass: "list-group-item navigatable text-center",
    attrs: {
      "data-action": "more-results"
    },
    on: {
      "click": _vm.moreResults
    }
  }, [_c('span', {
    attrs: {
      "data-action": "more-results"
    }
  }, [_vm._v("More results")])]) : _vm._e()])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28f54580","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/Search.vue
// module id = 388
// module chunks = 1